function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#235568;}\r\n\t.st1{fill:#EEA780;}\r\n\t.st2{fill:#3F4042;}\r\n\t.st3{fill:#CFB4B3;}\r\n\t.st4{fill:#1B2D57;}\r\n\t.st5{fill:#E8C9C7;}\r\n\t.st6{fill:none;stroke:#CFB4B3;stroke-width:4.4667;stroke-miterlimit:10;}\r\n\t.st7{fill:#D0D2D3;}\r\n\t.st8{fill:#9CDBF8;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M121.4035,425.7048c56.13,48.3935,128.4509,78.5026,207.611,80.9548c0-0.0199-0.02-0.0399-0.02-0.0399 c-0.678-2.3928-1.376-4.7256-2.114-7.0185c-0.7574-2.4328-1.5353-4.8055-2.3128-7.1185 c-22.1927-64.9831-54.9333-86.9365-54.9333-86.9365l-49.3304-40.3378c-0.0799-0.0199-14.9549-0.0199-29.9292-0.0199 c-15.2142,0-30.5077,0.0199-30.5077,0.0199s-4.0282,5.3038-10.1498,14.2568c-5.7619,8.4545-13.419,20.1786-21.3349,33.8174 c-1.1966,2.0541-2.4127,4.1676-3.6094,6.321c-1.0168,1.8147-2.0336,3.6489-3.0504,5.5031 C121.6228,425.3061,121.5033,425.5055,121.4035,425.7048z"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "159.8647,365.2107 269.6269,405.5392 280.7335,303.6985 192.9614,260.8318 172.3022,322.1507 "
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M142.3851,133.3763c21.7001-79.6867,66.9071-94.7674,131.4014-95.7512 c72.9544-1.1051,102.312,30.7517,112.5072,69.1224c4.0175,15.1337,0.4345,42.9257-2.5647,59.2895 c-2.7873,15.1366-5.9655,22.5617-6.2029,27.858c-0.6079,13.6988,8.9363,36.9617,18.1701,40.6389 c2.9992,1.1956,4.2451,8.691,3.3971,10.0284c-2.2813,3.6071-8.633,4.7921-13.2043,10.5982 c-7.815,9.9527-3.7317,20.2312-11.7586,35.423c-6.2917,11.9049-9.5111,29.7112-17.8611,46.0871 c-5.7815,11.338-41.032,18.2088-62.9579,9.2547c-47.5942-19.4333-125.3528-42.7059-138.7787-86.983 C141.1178,214.6712,136.5483,151.6774,142.3851,133.3763z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M106.5694,173.1048c1.5749-67.8091,33.9262-133.9443,85.4853-154.6541 c99.3541-39.9051,178.9835,38.425,206.6407,60.9077c18.9616,15.4214,17.9875,47.8781-12.4017,36.3822 c-105.5602-39.9409-136.4003,12.2529-136.4003,12.2529s-7.157,39.9437-6.5018,58.8504c0.6478,18.897-8.2714,40.2439-12.7739,36.7925 c-8.5804-44.694-15.6032-43.0401-15.6032-43.0401s-3.6684,15.1719-6.5119,58.6385c0,20.458-27.6117,76.0632-36.2005,82.9159 C158.2615,296.4011,105.574,215.9635,106.5694,173.1048z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M373.8887,249.2535c0,0,4.8274,4.1168,13.6123,4.1168c2.3783-3.3426,15.4367-9.0228,9.79-9.8429 C394.848,243.1723,373.8887,249.2535,373.8887,249.2535z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M369.9615,156.9904c-2.0182-3.7483-34.1868-2.2264-39.4115-1.2467 c-10.5652,1.981-23.1361,16.9963-21.34,19.2338c1.7924,2.2338,15.1612-8.1454,26.8853-7.2731 c4.5384,0.3406,27.3524,4.0759,30.3391,2.7529C369.4164,169.1292,371.9792,160.7379,369.9615,156.9904z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M269.6269,336.6534c0,0-29.0829-13.8238-36.851-21.5291c-7.769-7.6942-13.8693-44.3789-13.8693-44.3789 l19.4188,37.4463L269.6269,336.6534z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M226.0882,205.1493c-0.5224,20.6238,0.572,36.1046-14.735,33.8741 c-15.3066-2.2241-32.1714-17.1589-32.6616-37.7865c-0.5479-22.7178,12.2646-32.4344,24.9609-33.8179 C213.6288,166.3423,226.6714,182.1675,226.0882,205.1493z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M372.9435,292.9785c-6.6653-5.4938-28.6085-8.6906-37.0272-12.5973"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M349.3065,190.4162c-0.3545,5.161-3.6368,9.125-7.3285,8.8745c-3.6903-0.2565-6.3865-4.6479-6.0287-9.8086 c0.3615-5.1569,3.6368-9.1316,7.3284-8.8727C346.9723,180.8603,349.6671,185.2565,349.3065,190.4162z"
});

var _ref13 = /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "258.9488,212.7743 226.0882,205.1493 225.2256,193.8145 262.9034,203.3011 "
});

var _ref14 = /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "258.9488,275.4891 207.2883,248.4403 195.6957,232.4338 208.5027,239.2348 255.9351,263.64 "
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M313.3138,353.3263c0,0,29.9743-1.9857,41.1147-10.0806c25.3057-18.3848,48.4363-77.6888,48.4363-99.7328 c0-13.5384-21.8475-30.2104-22.5496-32.5557c-0.7069-2.3458-56.9224,8.3424-117.4118-7.6561 c-5.9283,4.7303-15.1338,43.3422-9.4856,62.847C269.6269,322.1507,313.3138,353.3263,313.3138,353.3263z"
});

var SvgCovid19 = function SvgCovid19(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCovid19, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/covid_19.58327d52.svg";
export { ForwardRef as ReactComponent };